import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField, FormControlLabel, Typography } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Checkbox from '@material-ui/core/Checkbox';
import Slider from '@material-ui/core/Slider';
import masks from '../Masks';
import isEqual from 'lodash/isEqual';

const currentDateConfiguration = { _relativeDate: 0 };

const styles = (theme) => ({
    whiteBackground: {
        backgroundColor: 'white',
    },
    grey: {
        color: grey[600],
    },
    checkbox: {
        marginLeft: theme.spacing(1),
    },
    rowsGrid: {
        alignItems: 'center',
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(2),
        marginBottom: theme.spacing(4),
    },
    textFieldGrid: {
        marginBottom: theme.spacing(2),
    },
    textField: {
        backgroundColor: 'white',
        '& input[type=number]': {
            '-moz-appearance': 'textfield',
        },
        '& input[type=number]::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
        },
        '& input[type=number]::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
        },
    },
    rowsHeading: { fontWeight: 'bold', color: '#484848' },
    sliderGrid: { paddingRight: theme.spacing(2), justifyContent: 'center', paddingTop: theme.spacing(2) },
});
class DefaultDetails extends React.Component {
    state = {
        tempMask: '',
        multiline: this.props.field?.multiline ? this.props.field.multiline : false,
        minRows: this.props.field?.minRows ? this.props.field.minRows : 3,
        maxRows: this.props.field?.maxRows ? this.props.field.maxRows : null,
        displayAllRows: !this.props.field?.maxRows,
        defaultCurrentDate:
            !!this.props.field?.initialValue && isEqual(this.props.field?.initialValue, currentDateConfiguration),
    };

    componentDidMount() {
        this.setTempMask();
    }

    componentDidUpdate(prevProps) {
        if (this.props.field.mask !== prevProps.field.mask) {
            this.setTempMask();
        }
    }

    setTempMask = () => {
        const mask = this.props.field.mask
            ? this.props.field.mask.map((element) => element.replace(/,/g, '\\,')).join(',')
            : '';
        this.setState({
            tempMask: mask,
        });
    };

    handleChangeMask = (newValue) => {
        const value = newValue?.value ? newValue.value : newValue;
        this.setState({
            tempMask: value,
        });
        let maskArr = value ? value.split(/(?<!\\),/) : [];
        maskArr = maskArr.map((element) => element.replace(/\\,/g, ','));
        let target = {
            id: 'mask',
            value: value ? maskArr : null,
        };
        this.props.handleChange({ target });
    };

    handleAllowMultipleLines = (event) => {
        this.setState({
            multiline: event.target.checked,
        });
        const target = {
            id: 'multiline',
            value: event.target.checked,
        };
        if (event.target.checked === true) {
            const target = {
                id: 'minRows',
                value: this.state.minRows,
            };
            this.props.handleChange({ target });
        }
        this.props.handleChange({ target });
    };

    onChangeMinRowsSlider = (value) => {
        this.setState({
            minRows: value,
        });
        let target = {
            id: 'minRows',
            value: value,
        };
        this.props.handleChange({ target });
    };

    onChangeMaxRowsSlider = (value) => {
        this.setState({
            maxRows: value,
        });
        let target = {
            id: 'maxRows',
            value: value,
        };
        this.props.handleChange({ target });
    };

    handleDisplayAllRows = (event) => {
        this.setState({
            displayAllRows: event.target.checked,
        });
        if (event.target.checked === false) {
            this.setState({
                maxRows: 6,
            });
            let target = {
                id: 'maxRows',
                value: 6,
            };
            this.props.handleChange({ target });
        } else if (event.target.checked === true) {
            this.setState({
                maxRows: null,
            });
            let target = {
                id: 'maxRows',
                value: null,
            };
            this.props.handleChange({ target });
        }
    };

    handleDefaultCurrentDate = (event) => {
        this.setState({
            defaultCurrentDate: event.target.checked,
        });
        if (event.target.checked) {
            const target = {
                id: 'initialValue',
                value: currentDateConfiguration,
            };
            this.props.handleChange({ target });
        } else {
            const target = {
                id: 'initialValue',
                value: null,
            };
            this.props.handleChange({ target });
        }
    };

    handleChangeDefaultAnswer = (event) => {
        let target = {
            id: event.target.id,
            value: event.target.value,
        };
        if (event.target.value !== '') {
            this.props.handleChange({ target });
        } else {
            target = { ...target, value: null };
            this.props.handleChange({ target });
        }
    };

    render() {
        const min = 0;
        const max = 20;
        const marks = [
            {
                value: 1,
                label: '1',
            },
            {
                value: 20,
                label: '20',
            },
        ];
        return (
            <React.Fragment>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            id="instructions"
                            label="Field Instructions"
                            value={this.props.field.instructions}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            multiline
                            className={this.props.classes.whiteBackground}
                            onChange={this.props.handleChange}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            id="label"
                            label="Field Label"
                            value={this.props.field.label}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            className={this.props.classes.whiteBackground}
                            onChange={this.props.handleChange}
                        />
                    </Grid>
                    {(this.props.field.typeId === 'textInput' || this.props.field.typeId === 'shortText') && (
                        <Grid item xs={12}>
                            <Autocomplete
                                freeSolo
                                id="mask"
                                disabled={!!this.state.multiline}
                                value={this.state.tempMask}
                                className={this.props.classes.whiteBackground}
                                options={masks}
                                getOptionLabel={(option) => {
                                    if (typeof option === 'string') {
                                        return option;
                                    }
                                    return option.label;
                                }}
                                onChange={(event, newValue) => {
                                    this.handleChangeMask(newValue);
                                }}
                                onInputChange={(event, newValue) => {
                                    this.handleChangeMask(newValue);
                                }}
                                renderOption={(option) => option.label}
                                renderInput={(params) => <TextField {...params} label="Mask" variant="outlined" />}
                            />
                        </Grid>
                    )}
                    {(this.props.field.typeId === 'textInput' || this.props.field.typeId === 'shortText') && (
                        <Grid item xs={12}>
                            <TextField
                                id="initialValue"
                                label="Default Answer"
                                value={this.props.field.initialValue ? this.props.field.initialValue : ''}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                className={this.props.classes.whiteBackground}
                                onChange={(e) => this.handleChangeDefaultAnswer(e)}
                            />
                        </Grid>
                    )}
                    {(this.props.field.typeId === 'textInput' || this.props.field.typeId === 'shortText') && (
                        <Grid item xs={12}>
                            <FormControlLabel
                                label={
                                    <Typography className={this.props.classes.grey}>
                                        Allow user to enter multiple lines
                                    </Typography>
                                }
                                control={
                                    <Checkbox
                                        id={'multiline'}
                                        name={'multiline'}
                                        checked={this.state.multiline}
                                        key={'multiline'}
                                        color={'primary'}
                                        className={this.props.classes.checkbox}
                                        onChange={(e) => this.handleAllowMultipleLines(e)}
                                        disabled={!!this.state.tempMask}
                                    />
                                }
                            />
                        </Grid>
                    )}

                    {this.state.multiline &&
                        (this.props.field.typeId === 'textInput' || this.props.field.typeId === 'shortText') && (
                            <>
                                <Grid container className={this.props.classes.rowsGrid}>
                                    <Grid item xs={6}>
                                        <Typography className={this.props.classes.rowsHeading} variant="subtitle1">
                                            Minimum Rows
                                        </Typography>
                                        <Typography>Number of rows to display before typing</Typography>
                                    </Grid>
                                    <Grid className={this.props.classes.sliderGrid} item xs={5}>
                                        <Slider
                                            aria-label="Minimum Rows"
                                            defaultValue={3}
                                            max={20}
                                            min={1}
                                            marks={marks}
                                            onChange={(e, value) => {
                                                this.onChangeMinRowsSlider(value);
                                            }}
                                            value={this.state.minRows}
                                        />
                                    </Grid>
                                    <Grid item xs={1} className={this.props.classes.textFieldGrid}>
                                        <TextField
                                            id="minRows"
                                            className={this.props.classes.textField}
                                            variant="outlined"
                                            value={this.state.minRows}
                                            onChange={(e) => {
                                                let value = e.target.value;
                                                if (value > max) value = max;
                                                if (value < min) value = min;
                                                this.onChangeMinRowsSlider(value);
                                            }}
                                            inputProps={{
                                                style: {
                                                    textAlign: 'center',
                                                },
                                            }}
                                            size="small"
                                            style={{
                                                width: 50,
                                            }}
                                            type="number"
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container className={this.props.classes.rowsGrid}>
                                    <Grid item xs={6}>
                                        <Typography className={this.props.classes.rowsHeading} variant="subtitle1">
                                            Maximum Rows
                                        </Typography>
                                        <Typography>Number of rows to display before scrolling is enabled</Typography>
                                        <FormControlLabel
                                            label={
                                                <Typography className={this.props.classes.grey}>
                                                    Display all rows
                                                </Typography>
                                            }
                                            control={
                                                <Checkbox
                                                    id={'displayAllRows'}
                                                    name={'displayAllRows'}
                                                    checked={this.state.displayAllRows}
                                                    key={'displayAllRows'}
                                                    color={'primary'}
                                                    onChange={(e) => this.handleDisplayAllRows(e)}
                                                />
                                            }
                                        />
                                    </Grid>
                                    <Grid className={this.props.classes.sliderGrid} item xs={5}>
                                        <Slider
                                            aria-label="Maximum Rows"
                                            defaultValue={3}
                                            max={20}
                                            min={1}
                                            marks={marks}
                                            disabled={this.state.displayAllRows}
                                            onChange={(e, value) => {
                                                this.onChangeMaxRowsSlider(value);
                                            }}
                                            value={this.state.maxRows}
                                        />
                                    </Grid>
                                    <Grid item xs={1} className={this.props.classes.textFieldGrid}>
                                        <TextField
                                            id="maxRows"
                                            className={this.props.classes.textField}
                                            variant="outlined"
                                            value={this.state.maxRows}
                                            onChange={(e) => {
                                                let value = e.target.value;
                                                if (value > max) value = max;
                                                if (value < min) value = min;
                                                this.onChangeMaxRowsSlider(value);
                                            }}
                                            inputProps={{
                                                style: {
                                                    textAlign: 'center',
                                                },
                                            }}
                                            size="small"
                                            style={{
                                                width: 50,
                                            }}
                                            type="number"
                                            disabled={this.state.displayAllRows}
                                        />
                                    </Grid>
                                </Grid>
                            </>
                        )}

                    {this.props.field.typeId === 'date' && (
                        <Grid item xs={12}>
                            <FormControlLabel
                                label={
                                    <Typography className={this.props.classes.grey}>
                                        Display current date as default
                                    </Typography>
                                }
                                control={
                                    <Checkbox
                                        id={'defaultCurrentDate'}
                                        name={'defaultCurrentDate'}
                                        checked={this.state.defaultCurrentDate}
                                        key={'defaultCurrentDate'}
                                        color={'primary'}
                                        className={this.props.classes.checkbox}
                                        onChange={(e) => this.handleDefaultCurrentDate(e)}
                                    />
                                }
                            />
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <TextField
                            id="additionalInfo"
                            label="Additional Information"
                            multiline
                            rows={4}
                            className={this.props.classes.whiteBackground}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            value={this.props.field.additionalInfo}
                            onChange={this.props.handleChange}
                        />
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    }
}
export default withStyles(styles)(DefaultDetails);
